import styled from '@emotion/styled'
import { Card } from '@material-ui/core'

export const CardContent = styled(Card)`
  box-shadow: none;
  padding: 30px 30px 20px;
  overflow: initial;
`
